import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import HtmlHead from '@components/HtmlHead'
import { withRouter } from 'next/router'
import { GlobalStyle, H160 } from '@components/shared'
import { colors } from '@components/shared/colors'
import TopNav from '@components/TopNav'
import { Container, Col, Row, config } from 'react-awesome-styled-grid'
import BackgroundGradient from '@components/BackgroundGradient'
import ReadyToListen from '@components/ReadyToListen'
import type { AppStateType } from '../../reducers/appstate'
import TopNavMobile from '@components/TopNavMobile'

type PropsType = {
  isDark: boolean,
  textSubscriptionConfirmationHeader: string,
  textSubscriptionConfirmationSubheader: string
}

function SubscribeConfirmed (props: PropsType): React.ReactNode {
  return (
    <ContainerDiv>
      <BackgroundGradient quadrant={3} overlayColor={props.isDark ? undefined : 'orange'}/>
      <HtmlHead
        title={'Dipsea | Subscribe'}
        description={'Get unlimited access to short, sexy audio stories, wellness sessions, and sleep scenes. Choose your subscription plan and start listening.'}
        image={'https://www.dipseastories.com/images/share-image-glow.jpg'}
      />
      <GlobalStyle backgroundColor={props.isDark ? colors.midnightBlue : colors.orange}/>
      <TopNav backgroundColor={props.isDark ? colors.midnightBlue : colors.orange95} isAssetLoaded={true}/>
      <TopNavMobile backgroundColor={props.isDark ? colors.midnightBlue : colors.orange95} isAssetLoaded={true}/>
      <Container>
        <Row>
          <Col align={'center'}>
            <HeaderContainer>
              <H160 color={colors.white} textAlign={'center'}>{props.textSubscriptionConfirmationHeader}</H160>
            </HeaderContainer>
          </Col>
        </Row>
        <Row align='center' justify='center'>
          <Col align={'center'} xs={4} sm={6} md={6} lg={5} xl={4}>
            <ReadyToListenContainer bgColor={props.isDark ? colors.midnightBlue : colors.white}>
              <ReadyToListen title={'Return to App'} color={props.isDark ? colors.white : colors.midnightBlue}/>
            </ReadyToListenContainer>
          </Col>
        </Row>
      </Container>
    </ContainerDiv>
  )
}

type OwnPropsType = {
  router: {
    query: {
      isDark?: string
    }
  }
}
const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): { isDark: any, textSubscriptionConfirmationHeader: any, textSubscriptionConfirmationSubheader: any } => {
  return {
    isDark: ownProps?.router?.query?.isDark === 'true',
    textSubscriptionConfirmationHeader: state.textSubscriptionConfirmationHeader,
    textSubscriptionConfirmationSubheader: state.textSubscriptionConfirmationSubheader
  }
}

export default withRouter(connect(mapStateToProps, {})(SubscribeConfirmed) as any) as any

const ContainerDiv = styled.div<any>`
  width: 100%;
`
const HeaderContainer = styled.div<any>`
  z-index: 1;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  ${(props: any): any => config(props).media.md`
    margin-top: 70px;
  `};
    max-width: 700px;
`

const ReadyToListenContainer = styled.div<any>`
  z-index: 1;
  background-color: ${(props: any): string => props.bgColor || colors.sand};
  border-radius: 26px;
  display: flex;
  justifying-content: center;
  align-items: center;
  padding: 36px 22px;
  margin: 30px 0px 60px 0px;
  ${(props: any): any => config(props).media.md`
    width: 100%;
    margin-top: 60px;
  `};
`
